/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Toast_Create_PxkInputs */

const vi_scl_toast_create_pxk = /** @type {(inputs: Scl_Toast_Create_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo phiếu xuất`)
};

/**

* @param {Scl_Toast_Create_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_toast_create_pxk = /** @type {((inputs?: Scl_Toast_Create_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Toast_Create_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_toast_create_pxk(inputs)
});